export default __webpack_public_path__ + "static/customer-profile-illustration-f3f778fd0853b10bd8daaad211f118db.svg";